import store from "../../store"
import api from "../../api/api";

export const authGuard = (to, from, next) => {
  store.getters.authenticated ? next() : next('/login')
};

export const checkPolicy = (to, from, next) => {
  if (store.getters.authenticated) {
    api.currentUser().then((res) => {
      console.log('res : ', res)
      switch (to.name) {
        case 'installation-show-c-a':
        case 'dashboard-under-perf':
        case 'dashboard-fleet':
        case 'dashboard-losses-waterfall':
        case 'expert':
        case 'expert-img':
        case 'expert-module':
        case 'smart-guard':
        case 'expert-pvsyst':
        case 'expert-incident':
        case 'expert-kpi':
        case 'dashboard-parc':    
        case 'expert-layout':
          // if (res['data']['policies']['installation_list'].includes(parseInt(to.params.id))
          //     || res['data']['policies']['installation_list'].includes(0)) {
          //   next()
          // } else next('/error')
          next()
          break;

        case 'create-audit':
          if (res['data']['policies']['create_audit'] === true) {
            next()
          } else next('/error')
          break;

        case 'plotly-creator':
          if (res['data']['policies']['plotly_creator'] === true) {
            next()
          } else next('/error')
          break;

        case 'pdf-report':
          if (res['data']['policies']['pdf_report'] === true
              && (res['data']['policies']['installation_list'].includes(parseInt(to.params.id))
              || res['data']['policies']['installation_list'].includes(0))) {
            next()
          } else next('/error')
          break;

        case 'analyst-mod':
          if (res['data']['policies']['analyst_mod'] === true
              && (res['data']['policies']['installation_list'].includes(parseInt(to.params.id))
              || res['data']['policies']['installation_list'].includes(0))) {
            next()
          } else next('/error')
          break;

        case 'virtual-sensor':
          if (res['data']['policies']['virtual_sensor'] === true) {
            next()
          } else next('/error')
          break;

        default:
          next('/login')
      }
    })
  } else {
    next('/login')
  }

};
